<button
  mat-stroked-button
  color="accent"
  [disabled]="isApiLoading"
  (click)="onExportXLS()"
>
  <mat-icon [svgIcon]="xlsIcon" class="file-type-icon"></mat-icon>Export
</button>
